<script setup lang="ts">
import type NewsItem from '@/types/NewsItem.ts'
import NewsItemBase from '@/components/Sections/News/Types/Base/NewsItemBase.vue'
import NewsItemBaseStructure from '@/components/Sections/News/Types/Base/NewsItemBaseStructure.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps<{
  newsItem: NewsItem
  toast: boolean
}>()
</script>

<template>
  <NewsItemBase
    :toast="toast"
    :toast-image="props.newsItem.contentData.profileImage"
    :toast-text="t('news.types.newPrivateChat.toast', { player: props.newsItem.contentData.nickname })"
  >
    <NewsItemBaseStructure
      :newsItem="props.newsItem"
      :item-image="props.newsItem.contentData.profileImage"
      :header="t('news.types.newPrivateChat.title', { player: props.newsItem.contentData.nickname })"
    >
      {{ t('news.types.newPrivateChat.body', { player: props.newsItem.contentData.nickname }) }}
    </NewsItemBaseStructure>
  </NewsItemBase>
</template>

<style scoped lang="scss"></style>
